import { Controller } from 'stimulus';

export default class TabsController extends Controller {
  static targets = ['button', 'wrapper'];

  activeIndex = 0;

  connect() {
    this.buttonTargets.forEach((button, i) => {
      if (button.classList.contains('active')) {
        this.activeIndex = i;
        this.wrapperTargets[i].classList.add('visible', 'active');
        this.updateURL(button.dataset.urlParameterValue);
      }

      button.addEventListener('click', this.onClick);
    });

    this.wrapperTargets.forEach((wrapper) => (
      wrapper.addEventListener('transitionend', this.onTransitionEnd)
    ));
  }

  disconnect() {
    this.buttonTargets.forEach((button) => {
      button.removeEventListener('click', this.onClick);
    });

    this.wrapperTargets.forEach((wrapper) => (
      wrapper.removeEventListener('transitionend', this.onTransitionEnd)
    ));
  }

  updateURL(value) {
    if (!value || !this.element.dataset.urlParameterName) {
      return;
    }

    const params = new URLSearchParams(window.location.search);
    params.set(this.element.dataset.urlParameterName, value);
    const { origin, pathname } = window.location;
    const url = `${origin}${pathname}?${params.toString()}`;

    if (window.Turbolinks) {
      window.Turbolinks.controller.replaceHistoryWithLocationAndRestorationIdentifier(
        url,
        window.Turbolinks.uuid(),
      );
    } else {
      window.history.replaceState({}, document.title, url);
    }
  }

  onClick = (event) => {
    const index = this.buttonTargets.indexOf(event.target);
    if (index < 0 || index === this.activeIndex) {
      return;
    }

    this.buttonTargets[this.activeIndex].classList.remove('active');
    this.wrapperTargets[this.activeIndex].classList.remove('active', 'visible');
    this.activeIndex = index;
    event.target.classList.add('active');
    const wrapper = this.wrapperTargets[index];
    this.element.classList.add('overflowed');
    wrapper.classList.add('visible');
    /* eslint-disable no-unused-expressions */
    wrapper.offsetWidth;
    wrapper.classList.add('active');
    this.updateURL(event.target.dataset.urlParameterValue);
  };

  onTransitionEnd = () => {
    this.element.classList.remove('overflowed');
  };
}
